import { DataTable } from "@marketplace/ui/data-table";

import { useProductListTableColumns } from "../../hooks/use-product-list-table-columns";
import type { ProductListItem } from "../../types";

type ProductListTableProps = {
  records: ProductListItem[];
  isDraft?: boolean;
};

export const ProductListTable: React.FC<ProductListTableProps> = ({
  records,
  isDraft = false
}) => {
  const columns = useProductListTableColumns(isDraft);

  return <DataTable minHeight={10} columns={columns} records={records} />;
};
